import { Slot } from 'expo-router';
import Head from 'expo-router/head';
import { Platform } from 'react-native';

export default function KursiPlayLayout() {
  return (
    <>
      {Platform.OS === 'web' && (
        <Head>
          <meta name="robots" content="noindex, nofollow" />
        </Head>
      )}
      <Slot />
    </>
  );
}
